module.exports = __webpack_public_path__ + "static/media/Korea_flag2.eca61e79.png";